import { DDD } from "./ddd/ddd";

const apiRequestAddress = process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";

// Shared by every "Reset your password" key icon (team page, user settings).
//
// The reset-password funnel is only routed for logged-out visitors (App.js), and the
// logged-in routes send any unknown address to /dashboard — so navigating there while signed
// in silently went nowhere. This signs out first, then opens the funnel. The address is
// handed over through sessionStorage (survives this same-tab navigation; ResetPassword reads
// it once and deletes it) rather than the URL, so it stays out of server logs and history.
export const resetOwnPassword = (email) => {
    try { sessionStorage.setItem("e2-reset-prefill-email", email || ""); } catch (e) {}
    const ddd = new DDD(apiRequestAddress);
    ddd.Rpc_ExecuteMethod("Auth.SignOut", {}).finally(() => {
        window.location.href = "@dashboard-resetpassword";
    });
};
